import React from "react";
import "./style.scss";
import cohartPG2 from "./img/cohort-program2.png";
import goldMember from "./img/gold-mentor.png";
import hostPG2 from "./img/host-program2.png";
import individulM2 from "./img/indivisual-mentor2.png";
import newMentor from "./img/new-mentor.png";
import platinumMentor from "./img/platinum-mentor.png";
import silverMentor from "./img/silver-mentor.png";
import startUpIndia from "./img/startup-india.jpg";
import HTMLReactParser from "html-react-parser";
import { useTranslation } from 'react-i18next';
export default function MentorBenefits(props) {
  const { t } = useTranslation();
  const keyData = props.data;
  return (
    <div className="mentor-benefitsBG">
      <section
        className="unique-needs"
      >
        <div className="w-100 pt-50 position-relative">
          <div className="container">
            <div className="row">
              <div className="sec-title text-center w-100 position-relative">
                <h2 className="mb-0 homepageFirstHeader">
                {t('Tier_Wise_Mentor_Benefits')}
                  {/* Tier Wise Mentor Benefits */}
                  </h2>
              </div>
            </div>
            <div className="row">
              <div className="col-md-1 col-sm-6 col-lg-1"></div>
              <div className="col-md-10 col-sm-6 col-lg-10">
                <div className="sec-title text-center w-100 position-relative">
                  <p className="homepageFirstDescription" style={{ fontSize: "20px", fontWeight: "normal" }}>
                  {t('Mentor_Badges')}
                 
                    {/* Earn Mentor Badges based on feedback of startups, time
                    committed, time to respond to startups, and number of
                    startups mentored. Move up in tiers as you contribute more. */}
                  </p>
                </div>
              </div>
              <div className="col-md-1 col-sm-6 col-lg-1"></div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div
              className="col-md-3 col-sm-6 col-lg-3 abovebenefitssec1"
            >
              <div className="benefits-sec">
                <a className="benefits-heading homepageFirstDescription" style={{ fontSize: "18px" }}>
                  EARN MENTORSHIP POINTS
                </a>
              </div>
            </div>
            <div
              className="col-md-3 col-sm-6 col-lg-3 abovebenefitssec2"
            >
              <div className="benefits-sec">
                <a className="benefits-heading homepageFirstDescription" style={{ fontSize: "18px" }}>
                  DOWNLOAD MENTOR BADGES
                </a>
              </div>
            </div>
            <div
              className="col-md-3 col-sm-6 col-lg-3 abovebenefitssec3"
            >
              <div className="benefits-sec">
                <a
                  className="benefits-heading homepageFirstDescription"
                  style={{ fontSize: "18px" }}
                >
                  SHOWCASE BADGES ON SOCIAL MEDIA
                </a>
              </div>
            </div>
            <div
              className="col-md-3 col-sm-6 col-lg-3 abovebenefitssec4"
            >
              <div className="benefits-sec">
                <a className="benefits-heading homepageFirstDescription" style={{ fontSize: "18px" }}>
                  TAG STARTUPINDIA ON SOCIAL MEDIA
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row pt-50">
            <div className="col-md-3 col-sm-6 col-lg-3">
              <div className="mentor-box">
                <div className="header-cart-box-mentor-btn position-relative d-inline-block">
                  <div className="tp-caption cart-btn position-relative">
                    <img src={newMentor} />
                    <div
                      className="minicart-dropdown-mentor-btn"
                      style={{ marginRight: "-120px" }}
                    >
                      <ul className="mentor-list">
                        <li className="listStyleposition">
                        {t('Special_badge_depicting')}
                          {/* Special badge depicting mentor tier and the duration
                          of status in that tier. Can be shared on social media.
                          (issued quarterly) */}
                        </li>
                      </ul>
                    </div>
                    <p className="mentor-text">
                      <img className="startupindialogo" src={startUpIndia} />
                    </p>
                  </div>{" "}
                </div>
              </div>
              <span></span>
            </div>
            <div className="col-md-3 col-sm-6 col-lg-3">
              <div className="mentor-box">
                <div className="header-cart-box-mentor-btn position-relative d-inline-block">
                  <div className="tp-caption cart-btn position-relative">
                    <img src={silverMentor} />
                    <div
                      className="minicart-dropdown-mentor-btn"
                    >
                      <ul className="mentor-list">
                        <li className="listStyleposition">
                        {t('Certificate_from_Startup')}
                          {/* Certificate from Startup India recognizing their
                          contributions (issued biannually) */}
                        </li>
                        <li className="listStyleposition">
                        {t('Special_badge_depicting')}
                          {/* Special badge depicting mentor tier and the duration
                          of status in that tier. Can be shared on social media.
                          (issued quarterly) */}
                        </li>
                        <li className="listStyleposition">
                        {t('Access_to_training_modules')}
                        
                          {/* Access to training modules and individual sessions
                          with experienced mentors to help improve mentorship
                          abilities */}
                        </li>
                      </ul>
                    </div>
                    <p className="mentor-text">
                    <img className="startupindialogo" src={startUpIndia} />
                    </p>
                  </div>{" "}
                </div>
              </div>
              <span></span>
            </div>
            <div className="col-md-3 col-sm-6 col-lg-3">
              <div className="mentor-box">
                <div className="header-cart-box-mentor-btn position-relative d-inline-block">
                  <div className="tp-caption cart-btn position-relative">
                    <img src={goldMember} />
                    <div
                      className="minicart-dropdown-mentor-btn"
                      style={{ width: "500px" }}
                    >
                      <ul className="mentor-list">
                        <li className="listStyleposition">
                        {t('Invitation_to_Startup')}
                          {/* Invitation to Startup India’s national and
                          international events as speaker and guest with full
                          access */}
                        </li>
                        <li className="listStyleposition">
                        {t('Letter_of_appreciation')}
                          {/* Letter of appreciation from DPIIT* (retaining mentor
                          status Tier in for two consecutive quarters) */}
                        </li>
                        <li className="listStyleposition">
                        {t('Special_coverage_website')}
                          {/* Special coverage on the Startup India’s website with
                          details of contribution to the program{" "} */}
                        </li>
                        <li className="listStyleposition">
                        {t('Special_coverage_on_the_Startup_media')}
                          {/* Special coverage on the Startup India’s social media
                          handles with details of contribution to the program{" "} */}
                        </li>
                        <li className="listStyleposition">
                        {t('Certificate_from_Startup')}
                          {/* Certificate from Startup India recognizing their
                          contributions (issued biannually) */}
                        </li>
                        <li className="listStyleposition">
                        {t('Special_badge_depicting')}
                        
                          {/* Special badge depicting mentor tier and the duration
                          of status in that tier. Can be shared on social media.
                          (issued quarterly) */}
                        </li>
                        <li className="listStyleposition">
                        {t('Access_to_training_modules')}
                          {/* Access to training modules and individual sessions
                          with experienced mentors to help improve mentorship
                          abilities */}
                        </li>
                      </ul>
                    </div>
                    <p className="mentor-text">
                    <img className="startupindialogo" src={startUpIndia} />
                    </p>
                  </div>{" "}
                </div>
              </div>
              <span></span>
            </div>
            <div className="col-md-3 col-sm-6 col-lg-3">
              <div className="mentor-box lastBadge">
                <div className="header-cart-box-mentor-btn position-relative d-inline-block">
                  <div className="tp-caption cart-btn position-relative">
                    <img src={platinumMentor} />
                    <div
                      className="minicart-dropdown-mentor-btn"
                      style={{ width: "500px" }}
                    >
                      <ul className="mentor-list">
                        <li className="listStyleposition">
                        {t('Invitation_to_Startup')}
                          {/* Invitation to Startup India’s national and
                          international events as speaker and guest with full
                          access */}
                        </li>
                        <li className="listStyleposition">
                        {t('Access_to_networking_opportunities')}
                          {/* Access to networking opportunities with stakeholders
                          associated with Startup India through individual
                          requests or through events */}
                        </li>
                        <li className="listStyleposition">
                        {t('Letter_of_appreciation')}
                          {/* Letter of appreciation from DPIIT* (retaining mentor
                          status Tier in for two consecutive quarters) */}
                        </li>
                        <li className="listStyleposition">
                        {t('Special_coverage_website')}
                          {/* Special coverage on the Startup India’s website with
                          details of contribution to the program{" "} */}
                        </li>
                        <li className="listStyleposition">
                        {t('Special_coverage_on_the_Startup_media')}
                          {/* Special coverage on the Startup India’s social media
                          handles with details of contribution to the program{" "} */}
                        </li>
                        <li className="listStyleposition">
                        {t('Annual_meeting')}
{/*                         
                          Annual meeting/roundtable with Hon'ble Minister of
                          Commerce & Industry to discuss startup related
                          subjects */}
                        </li>
                        <li className="listStyleposition">
                        {t('Certificate_from_Startup')}
                          {/* Certificate from Startup India recognizing their
                          contributions (issued biannually) */}
                        </li>
                        <li className="listStyleposition">
                        {t('Opportunity_to_serve')}
                        
                          {/* Opportunity to serve as a committee member for other
                          startup initiatives under Startup India */}
                        </li>
                        <li className="listStyleposition">
                        {t('Special_badge_depicting')}
                          {/* Special badge depicting mentor tier and the duration
                          of status in that tier. Can be shared on social media.
                          (issued quarterly) */}
                        </li>
                      </ul>
                    </div>
                    <p className="mentor-text">
                    <img className="startupindialogo" src={startUpIndia} />
                    </p>
                  </div>{" "}
                </div>
              </div>
              <span></span>
            </div>
          </div>
        </div>
      </section>
      <section
        className="contribute-bg"
      >
        <div className="w-100 pt-50 position-relative">
          <div className="container">
            <div className="row">
              <div className="sec-title text-center w-100 position-relative">
                <h2 className="mb-0 homepageFirstHeader">
                {t('How_to_Contribute')}
                
                  {/* How to Contribute */}
                  </h2>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row pt-50">
            <div className="col-md-4 col-sm-6 col-lg-4">
              <div className="contribute-box">
                <img src={individulM2} />
                <br />
                <p>
                  <a className="contribute " title="">
                    {keyData[0].Heading}
                  </a>
                </p>
                <p className="contribute-text homepageFirstDescription">
                  {HTMLReactParser(keyData[0].Text)}
                </p>
              </div>
            </div>

            <div className="col-md-4 col-sm-6 col-lg-4">
              <div className="contribute-box">
                <img src={cohartPG2} /> <br />
                <p>
                  <a className="contribute " title="">
                    {keyData[1].Heading}
                  </a>
                </p>
                <p className="contribute-text homepageFirstDescription">
                  {HTMLReactParser(keyData[1].Text)}
                </p>
              </div>
            </div>
            <div className="col-md-4 col-sm-6 col-lg-4">
              <div className="contribute-box">
                <img src={hostPG2} /> <br />
                <p>
                  <a className="contribute" title="">
                    {keyData[2].Heading}
                  </a>
                </p>
                <p className="contribute-text homepageFirstDescription">
                  {HTMLReactParser(keyData[2].Text)}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
